import { render, staticRenderFns } from "./statementManagementFinance.vue?vue&type=template&id=23c0dcfc"
import script from "./statementManagementFinance.vue?vue&type=script&lang=js"
export * from "./statementManagementFinance.vue?vue&type=script&lang=js"
import style0 from "./statementManagementFinance.vue?vue&type=style&index=0&id=23c0dcfc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports